export const convertImagesToBase64 = async (images) => {
  const entries = await Promise.all(
    Object.entries(images).map(async ([filename, file]) => {
      if (!file) return [filename, null];

      // If already a base64 string (data URL), just return it
      if (typeof file === "string" && file.startsWith("data:")) {
        return [filename, file];
      }

      // Only proceed if it's truly a File or Blob
      if (!(file instanceof Blob)) {
        // Not a Blob/File (shouldn't happen), fallback to null
        return [filename, null];
      }

      const base64DataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
      });
      // base64DataUrl is in format "data:<mime-type>;base64,<data>"
      return [filename, base64DataUrl];
    })
  );

  return Object.fromEntries(entries);
};